import { UntypedFormGroup } from '@angular/forms'

export function resetValidators(form: UntypedFormGroup) {
  let controls = form.controls
  for (let key in controls) {
    if (controls.hasOwnProperty(key)) {
      let control = controls[key]
      control.setValidators([])
      control.updateValueAndValidity()
    }
  }
}
